import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=34cfcb04&scoped=true"
import script from "./appoint.vue?vue&type=script&lang=js"
export * from "./appoint.vue?vue&type=script&lang=js"
import style0 from "./appoint.vue?vue&type=style&index=0&id=34cfcb04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cfcb04",
  null
  
)

export default component.exports